export default __webpack_public_path__ + "static/media/why_img_2.45b0c746.png";